import { useEffect, useState } from "react";

import CarouselItem from "MiniSiteComponents/Carousel/Carousel.interface";
import { ContentShowListProps as Props } from "MiniSiteComponents/ContentShow/ContentShow.interface";
import Helper from "Interfaces/Helper";
import MobileCircles from "./Mobile/Mobile_CirclesList";
import RowTabs from "./Desktop/Desktop_TabsRow";
import ShowMoreButton from "GeneralComponents/ShowMoreButton";
import Consts from "Interfaces/Consts";

import "./Circles.min.css";

const largeMediaType = window.matchMedia("(min-width: 1024px)");
const mediumMediaType = window.matchMedia("(min-width: 768px) and (max-width: 1024px)");

const CirclesList: React.FC<Props> = (props) => {
  const [isShowMore, setIsShowMore] = useState(false);
  const [closeAllButThis, setCloseAllButThis] = useState("");
  const [activeIndexOnSelectedTab, setActiveIndexOnSelectedTab] = useState(999);

  const limitOfLargeCircles: number = calculateLimitOfLargeCircles(props.items);
  const itemsPerRow: number = calculateItemsPerRow(props.items);
  const circlesBeforeButton: number = props.hideShowMoreButton
    ? props.items.length
    : calculateCirclesBeforeButton(props.items);
  const hasLargeCircles = props.items.length <= limitOfLargeCircles;
  const itemsNumClass = hasLargeCircles ? " mst-four-circlesItem" : "";
  const hasShowMoreBtn = props.items.length > circlesBeforeButton;

  function calculateItemsPerRow(items: CarouselItem[]) {
    if (items.length == 0) return 0;

    // If a valid `itemsNumberInRow` is provided (1–6), respect it on
    // breakpoints that can fit multiple circles per row. The "999" sentinel
    // and other out-of-range values fall through to the default logic below.
    const requested = Number(props.itemsNumberInRow);
    const hasRequested = Number.isFinite(requested) && requested > 0 && requested <= 6;

    if (largeMediaType.matches) {
      if (hasRequested) return Math.min(requested, items.length);
      if (items.length == 6) return 3;
      if (items.length == 7) return 4;
      return 5;
    }
    if (mediumMediaType.matches) {
      if (hasRequested) return Math.min(requested, items.length, 3);
      return items.length == 4 ? 2 : 3;
    }

    return 1;
  }

  function calculateCirclesBeforeButton(items: CarouselItem[]) {
    if (mediumMediaType.matches && items.length > 0) {
      return items.length == 4 ? 4 : 9;
    }
    return 10;
  }

  function calculateLimitOfLargeCircles(items: CarouselItem[]) {
    if (mediumMediaType.matches && items.length > 0) {
      return items.length == 4 ? 4 : 2;
    }
    return 4;
  }

  const changeShowMore = () => {
    try {
      if (!isShowMore) {
        Helper.handleLinkClicksGA4("Circles View", props.title, "more items");
      }
      setIsShowMore((prev) => !prev);
    } catch (e) {}
  };

  const closeOtherTabs = (tabItemId: string, selectedIndex: number) => {
    setCloseAllButThis(tabItemId);
    setActiveIndexOnSelectedTab(selectedIndex);
  };

  useEffect(() => {
    const componentRoot = document.getElementById(props.componentId);
    componentRoot.style.backgroundColor = "#FFFFFF";
  }, []);

  return (
    <article className={`mst-Circles-Component ${props.noImagesClass} ${"d-flex justify-content-" + props.alignment}`}>
      {largeMediaType.matches || mediumMediaType.matches ? (
        <div className="accordion mst-circlesView-tabs" id={props.componentId + "_tabs"}>
          <div>
            <div>
              {props.items.map((item, idx) => {
                const displayItem = idx % itemsPerRow == 0 || idx == 0;
                const showItem = idx < circlesBeforeButton ? true : isShowMore;

                if (!displayItem) return null;

                return (
                  <RowTabs
                    key={`${props.componentId}_${idx + 1}_${isShowMore ? 1 : 0}_${closeAllButThis}`}
                    tabItemId={`${props.componentId}_${idx + 1}`}
                    items={props.items.slice(idx, idx + itemsPerRow)}
                    componentId={props.componentId}
                    direction={props.dir}
                    largeCircles={hasLargeCircles}
                    isShow={showItem}
                    activeTab={activeIndexOnSelectedTab}
                    closeAllButThis={closeAllButThis}
                    closeOthers={closeOtherTabs}
                    setActiveIndexOnSelectedTab={setActiveIndexOnSelectedTab}
                    componentTitle={props.title}
                    linkTarget={props.linkTarget}
                  />
                );
              })}
            </div>
            {hasShowMoreBtn && (
              <div className="text-center">
                <ShowMoreButton
                  showMore={changeShowMore}
                  btnClass="btn btn-outline-primary mst-btn px-5 mx-auto mt-4 mst-show-more-btn "
                  txtOpen={`${Consts.showMore} (${props.items.length - circlesBeforeButton})`}
                  txtClose={Consts.close}
                  isOpen={isShowMore}
                ></ShowMoreButton>
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className={`accordion mst-circlesView-accordion ${itemsNumClass}`} id={props.componentId + "_accordion"}>
          <MobileCircles
            contentShowItems={props.items}
            componentId={props.componentId}
            direction={props.dir}
            componentTitle={props.title}
            linkTarget={props.linkTarget}
          />
        </div>
      )}
    </article>
  );
};

export default CirclesList;
